import React from 'react';
import { useForm } from 'react-hook-form';
import { Link, useHistory } from 'react-router-dom';
import isEmail from 'validator/es/lib/isEmail';
import { useAuth } from '../../common/auth';
import { validatePassword } from '../../common/passwordValidator';
import { IFormInput } from '../Form';
import LandingTemplate from '../LandingTemplate';

export default function Login() {
  const formHook = useForm();
  const history = useHistory();
  const { login } = useAuth();

  const inputs: IFormInput[] = [
    {
      name: 'username',
      label: 'Email Address',
      type: 'email',
      validate: {
        email: value => isEmail(value)
      },
      required: true
    },
    {
      name: 'password',
      label: 'Password',
      type: 'password',
      validate: {
        password: value => validatePassword(value)
      },
      required: true
    }
  ];

  const onSubmit = (data: any) => {
    login(data)
      .then(() => history.push('/status'))
      .catch(() => { });
  };

  return <LandingTemplate form={{
    submitCaption: "Login",
    inputs,
    onSubmit,
    formHook,
    children: <Link to="/initiate-password-reset">Forgot password?</Link>
  }} />;
}